<template>
  <div class="plan-details">
    <h2 class="plan-details__title">
      <slot name="title"></slot>
    </h2>
    <div class="plan-details__price text-lowercase">
      <slot name="price"></slot>
    </div>
    <p class="plan-details__desc">
      <slot name="desc"></slot>
    </p>
    <slot name="action"></slot>
  </div>
</template>
<script>
export default {
    name: 'PlanDetailsBase',
}
</script>
<style scoped lang="scss">
@import '@/styles/scss-utils.scss';

.plan-details {
    &__title {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
    }

    &__price {
        margin-top: 4px;
    }

    &__desc {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        margin: 16px 0;
    }
}
</style>
